import { ValidatorFn } from '@angular/forms';
import { ButtonStyles } from './Button';

export enum InputType {
  Date = 'date',
  DateTimeLocal = 'datetime-local',
  Email = 'email',
  Month = 'month',
  Number = 'number',
  Password = 'password',
  Search = 'search',
  Tel = 'tel',
  Text = 'text',
  Time = 'time',
  Url = 'url',
  Week = 'week',
}
export enum Field {
  Text = 'text',
  Textarea = 'textarea',
  Select = 'select',
  Checkbox = 'checkbox',
  DateTime = 'datetime',
  Custom = 'Custom ',
}

export interface InputOptions {
  id: string;
  value: string;
  label: string;
}

export interface Input {
  field?: Field;
  type?: InputType;
  placeholder?: string;
  formControlName?: string;
  mask?: string | null;
  value?: string | number | boolean;
  rows?: number;
  cols?: number;
  inline?: boolean;
  options?: InputOptions[];
  label?: string;
  validators?: ValidatorFn[];
  buttonStyles?: ButtonStyles;
}
